import Container from '@atoms/Container';
import ArrowDownIcon from '@images/svg/arrow-down.svg';
import { graphql } from 'gatsby';
import React from 'react';
import Link from "../primitives/link";
import Button from "../primitives/button";
import { colors } from '../primitives/colors/index.tsx';

const Subnav = ({ data }) => {
    const { subnav } = data || {};
    const { title, nav_link: links } = (subnav && Array.isArray(subnav) && subnav[0]) ? subnav[0] : {};
    const [mobileDropdownVisible, setMobileDropdownVisible] = React.useState(false);

    if (!title && !links) {
        return null;
    }

    return (
        <nav css={styles.nav} aria-labelledby="subnav-label">
            <h3 css={styles.navLabel} id="subnav-label">{`${title} Sub Navigation`}</h3>
            <Container>
                <ul css={styles.navLinks}>
                    {links.map(link => (
                        <Link
                            css={styles.navLink}
                            className="hover-default"
                            to={link.href}
                            key={link.title}>
                            {link.title}
                        </Link>
                    ))}
                </ul>
                <div
                    css={styles.buttonWrap}
                    onClick={() => setMobileDropdownVisible(state => !state)}
                >
                    <Button css={styles.button}>
                        {title}
                        <ArrowDownIcon css={styles.arrowDownIcon(mobileDropdownVisible)} />
                    </Button>
                </div>
            </Container>
            <div
                css={styles.mobileDropdown(mobileDropdownVisible)}
                visible={mobileDropdownVisible}
            >
                <Container css={styles.mobileDropdownLinksWrap}>
                    {links.map(link => (
                        <Link
                            className="hover-default"
                            css={styles.mobileDropdownLink}
                            to={link.href}
                            key={link.title}
                        >
                            {link.title}
                        </Link>
                    ))}
                </Container>
            </div>
        </nav>
    );
};

const styles = {
    nav: {
        position: "relative",
        paddingTop: "0.75rem",
        paddingBottom: "0.75rem",
        color: colors.shadesWhite,
        background: colors.primaryOrange,
        "@media (min-width: 1280px)": {
            paddingTop: "1rem",
            paddingBottom: "1rem"
        }
    },
    navLabel: {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: "0"
    },
    navLinks: {
        display: "none",
        "@media (min-width: 1280px)": {
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            display: "flex"
        }
    },
    navLink: {
        fontWeight: 400,
        borderRight: "1px solid white",
        paddingRight: "9px",
        marginRight: "10px",
        "&:last-of-type": {
            marginRight: 0,
            borderColor: "transparent",
        }
    },
    mobileDropdown: (visible) => ({
        backgroundColor: colors.primaryOrange,
        position: "absolute",
        left: "0",
        top: "100%",
        zIndex: 30,
        width: "100%",
        transition: `max-height ${visible ? "1s" : "0.5s"} ease-in`,
        maxHeight: visible ? "1500px" : 0,
        overflow: "hidden",
        "@media (min-width: 1280px)": { 
            display: "none" 
        }
    }),
    button: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%"
    },
    buttonWrap: {
        position: "relative",
        fontSize: "1.5rem",
        lineHeight: "2rem",
        color: "#ffffff",
        backgroundColor: colors.primaryOrange,
        "@media (min-width: 1280px)": {
            display: "none"
        }
    },
    arrowDownIcon: (mobileDropdownVisible) => ({
        marginRight: "auto",
        marginLeft: "auto",
        transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        transform: mobileDropdownVisible && "rotate(180deg)",
    }),
    mobileDropdownLinksWrap: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    mobileDropdownLink: {
        paddingTop: "1rem",
        paddingBottom: "1rem",
        fontSize: "1.125rem",
        lineHeight: "1.75rem"
    }
};

export const query = graphql`
  fragment SubnavData on CmsPageBuilderBlocks {
    subnav_stripe {
      subnav {
        title
        nav_link {
          href
          title
        }
      }
    }
  }
`;

export default Subnav;
